import React from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import OrderPage from './components/OrderPage';
import Table from './components/Table';
import ProductPage from './components/ProductPage';
import OrderDetailPage from './components/OrderDetailPage';
import { CartProvider } from './contexts/CartContext';



function App() {
  return (
    <CartProvider>
      <Router>
        <Routes>
          <Route path="/" element={<Navigate to="/table" replace />} />
          <Route path="/products" element={<ProductPage />} />
          <Route path="/order" element={<OrderPage />} />
          <Route path="/order-detail" element={<OrderDetailPage />} />
          <Route path="/table" element={<Table />} />
        </Routes>
      </Router>
    </CartProvider>
  );
}

export default App; 